export function addSpacesToTitleCaseString(titleCaseString) {
  const characters = titleCaseString.split('');
  for (let i = 1; i < characters.length; i++) {
      if (isUpperCase(characters[i]) && !isUpperCase(characters[i - 1]) && characters[i - 1] !== '-' ) {
        characters.splice(i, 0, ' ');
        i++;
      }
  }
  return characters.join('');
}

export function isUpperCase(character) {
  return character && character == character.toUpperCase() && character !== character.toLowerCase()
}